<script>
  import { afterUpdate, createEventDispatcher, onMount } from "svelte"
  import ApplicationState from "../../../../Stores/applicationStates"
  import { generateHTMLContent } from "../../../../Script/generateHTMLContent"
  import notify from "../../../../Script/notify"
  import { loadTooltip } from "../../../../Script/loadTooltip"
  import { postRequest } from "../../../../Script/apiMethods"
  export let flatObject = {}
  export let translateposition = ""
  /**
   * @type {import("../../../../../Script/types").EmailTemplate}
   */
  export let emailTemplate = {}
  export let card = false

  const dispatch = createEventDispatcher()

  let notification = {
    close() {},
  }
  /**
   * @type {HTMLElement} binded the input element
   */
  let input
  /**
   * @type {String} binding the email address to which the test email will be send
   */
  let toAddress = ""
  /**
   * @type {HTMLElement} the html element for the email content
   */
  let htmlContent
  /**
   * @type {Boolean} whether to disable the sent button or not
   */
  let disableSentbtn = false
  /**
   * @type {RegExp} regex pattern for validating the email address
   */
  let emailAddressPattern = /^[A-Z0-9.!#$%&'+/=?^_`{|}~-]+@[A-Z0-9-]+(?:\.[A-Z0-9-]+){1,}$/i
  /**
   * @type {String} parsed email content from the editor content
   */
  let parsedContent

  let overallCard

  onMount(async () => {
    parseContent()
  })

  // afterUpdate(() => {
  //   parseContent()
  // })

  /**
   * @description Function for sending the test email
   */
  const sendTestEmail = async () => {
    try {
      if (!input.value) {
        input.focus()
        return
      }
      if (toAddress) {
        toAddress = toAddress.trim()
      }

      if (!emailAddressPattern.test(toAddress)) throw "Enter Valid Email address"

      // request body for the send email api
      let reqBody = {
        to: toAddress.trim(),
        subject: emailTemplate.subject,
        content: generateHTMLContent(emailTemplate, parsedContent),
        // tag: emailTemplate.id,
        tag: `::${$ApplicationState.issuerID}:templateTest`,
      }

      await postRequest(`/api/swagger/v2/email/send`, reqBody, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      notify.success("Test email sent sucessfully.You will able to send test mail after 10s if you needed.")
      disableSentbtn = true
      setTimeout(() => {
        disableSentbtn = false
      }, 10000)
    } catch (error) {
      const info = "PAGE: Edit Email template\nEVENT: While sending test email from preview"
      notify.danger(error, info)
    }
  }

  /**
   * @description Function for the parsing the emailtemplate content values
   */
  const parseContent = () => {
    parsedContent = emailTemplate.content

    let editorValues = Array.from(new Set(emailTemplate.content.match(/(?<=\{\{).*?(?=\}\})/g)))

    const linkedInMatches = emailTemplate.content.match(/\[\[(.*?)\]\]/g)

    if (linkedInMatches) {
      const linkedInValues = [...new Set(linkedInMatches.map((match) => match.slice(2, -2)))]

      for (let i = 0; i < linkedInValues.length; i++) {
        if (linkedInValues[i] == "cert_url") {
          parsedContent = parsedContent.replaceAll(`[[${linkedInValues[i]}]]`, "https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592")
        } else if (linkedInValues[i] == "cert_ID") {
          parsedContent = parsedContent.replaceAll(`[[${linkedInValues[i]}]]`, "documentID")
        } else if (linkedInValues[i] == "document_type") {
          parsedContent = parsedContent.replaceAll(`[[${linkedInValues[i]}]]`, "Certificate")
        } else if (linkedInValues[i] == "issue_Year") {
          parsedContent = parsedContent.replaceAll(`[[${linkedInValues[i]}]]`, new Date().getFullYear())
        } else if (linkedInValues[i] == "issue_Month") {
          parsedContent = parsedContent.replaceAll(`[[${linkedInValues[i]}]]`, new Date().getMonth() + 1)
        } else if (linkedInValues[i] == "expire_Year") {
          parsedContent = parsedContent.replaceAll(`[[${linkedInValues[i]}]]`, new Date().getFullYear() + 1)
        } else if (linkedInValues[i] == "expire_Month") {
          parsedContent = parsedContent.replaceAll(`[[${linkedInValues[i]}]]`, new Date().getMonth() + 1)
        }
      }
    }

    if (editorValues.length && Object.keys(flatObject).length) {
      for (let i = 0; i < editorValues.length; i++) {
        if (flatObject[editorValues[i]]) {
          parsedContent = parsedContent.replaceAll(`{{${editorValues[i]}}}`, flatObject[editorValues[i]])
        } else if (editorValues[i] == "url") {
          parsedContent = parsedContent.replaceAll(`{{url}}`, `<a href="https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592" target="_blank" rel="noreferrer" style="color:inherit; overflow-wrap: break-word;" ><strong>https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592</strong></a>`)
        } else if (editorValues[i] == "receiver_name") {
          parsedContent = parsedContent.replaceAll(`{{${editorValues[i]}}}`, "John Doe")
        } else if (editorValues[i] == "document_type") {
          parsedContent = parsedContent.replaceAll(`{{${editorValues[i]}}}`, "Certificate")
        } else if (editorValues[i] == "issuer_signatory") {
          parsedContent = parsedContent.replaceAll(`{{${editorValues[i]}}}`, "Controller")
        } else if (editorValues[i] == "cert_url") {
          // parsedContent = parsedContent.replaceAll(`{{${editorValues[i]}}}`, "https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592")
        } else if (editorValues[i] == "cert_ID") {
          // parsedContent = parsedContent.replaceAll(`{{${editorValues[i]}}}`, flatObject["documentID"])
        } else {
          parsedContent = parsedContent.replaceAll(`{{${editorValues[i]}}}`, `<strong>${editorValues[i]}</strong>`)
        }
      }
    }

    // if (Object.keys(flatObject).length) {
    //   for (const [key, value] of Object.entries(flatObject)) {
    //     if (value) {
    //       parsedContent = parsedContent.replace(`{{${key}}}`, value)
    //     } else if (key == "receiver_name") {
    //       parsedContent = parsedContent.replace(`{{${key}}}`, "John Doe")
    //     } else if (key == "url") {
    //       parsedContent = parsedContent.replaceAll(`{{${key}}}`, `<a href="https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592" target="_blank" rel="noreferrer" style="color:inherit; overflow-wrap: break-word;" ><strong>https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592</strong></a>`)
    //     } else if (parsedContent.match(/(?<=\{\{).*?(?=\}\})/g)) {
    //       let tempValues = Array.from(new Set(parsedContent.match(/(?<=\{\{).*?(?=\}\})/g)))
    //       for (let i = 0; i < tempValues.length; i++) {
    //         if (tempValues[i] == "url") {
    //           parsedContent = parsedContent.replaceAll(`{{url}}`, `<a href="https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592" target="_blank" rel="noreferrer" style="color:inherit; overflow-wrap: break-word;" ><strong>https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592</strong></a>`)
    //         } else {
    //           parsedContent = parsedContent.replace(`{{${tempValues[i]}}}`, `<strong>${tempValues[i]}</strong>`)
    //         }
    //       }
    //     } else {
    //       parsedContent = parsedContent.replace(`{{${key}}}`, `<strong>${key}</strong>`)
    //     }
    //   }
    // } else {
    //   parsedContent = parsedContent.replace(`{{receiver_name}}`, "John Doe")
    //   parsedContent = parsedContent.replaceAll(`{{url}}`, `<a href="https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592" target="_blank" rel="noreferrer" style="color:inherit; overflow-wrap: break-word;" ><strong>https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592</strong></a>`)
    // }
    htmlContent = generateHTMLContent(emailTemplate, parsedContent)
  }

  $: parseContent(emailTemplate)

  afterUpdate(() => {
    loadTooltip()
    window.addEventListener("resize", loadTooltip)
  })
</script>

<div bind:this={overallCard} class:card class="{translateposition} isList min-h-full min-w-[370px] select-none rounded-md bg-white p-3 text-left dark:bg-[#414141] mobile:min-w-[350px] mobile:p-6 sm:min-w-[600px] md:min-w-[700px] lg:min-w-[900px] xl:min-w-[1200px]">
  <div id="previewCard" class="flex w-full items-center justify-between text-gray-300">
    <h1 class="text-base font-extrabold text-gray-900 dark:text-white mobile:text-xl">Email Preview</h1>
    <div class="flex gap-3">
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div name="tooltip" id="Close Preview" tooltip-position="top" on:click={() => dispatch("closePreview")} class="flex h-9 w-full cursor-pointer select-none items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-2 text-sm font-medium text-slate-800 hover:bg-red-600 hover:text-white focus:outline-none active:bg-red-500 dark:bg-lightgray dark:text-white dark:hover:bg-red-500 mobile:w-fit">
        <i class="fa-solid fa-circle-xmark" />
        <span class="hidden lg:block">&nbsp;&nbsp;Close&nbsp;Preview</span>
        <!-- <span class="hidden xl:block">&nbsp;Preview</span> -->
      </div>
      <button name="tooltip" id="Send Test Email" tooltip-position="top" disabled={disableSentbtn} on:click={sendTestEmail} class="flex h-9 w-full select-none items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-2 text-sm font-medium text-slate-800 hover:bg-green-600 hover:text-white focus:outline-none active:bg-green-500 disabled:cursor-not-allowed disabled:bg-[#f7f7f7]/50 disabled:text-slate-800/50 dark:bg-lightgray dark:text-white dark:hover:bg-green-500 mobile:w-fit">
        <i class="fa-solid fa-envelope" />
        <span class="hidden lg:block">&nbsp;&nbsp;Send&nbsp;Test&nbsp;Email</span>
        <!-- <span class="hidden xl:block">&nbsp;Preview</span> -->
      </button>
    </div>
  </div>
  <div class="my-3 space-y-3">
    <div class="grid grid-cols-4 items-center">
      <div class="mb-1 {card ? 'text-right' : ''} col-span-4 select-none text-base font-medium text-gray-200 mobile:col-span-1 sm:mb-0">From</div>
      <div class="col-span-4 mobile:col-span-3 sm:mt-0">
        <h1 class="py-2 pl-5 text-sm font-normal text-slate-800 dark:text-slate-200 mobile:text-base">
          {$ApplicationState.pmEmail || "Docchain Documents <docs@support.print2block.in>"}
        </h1>
      </div>
    </div>
    <div class="sm:grid sm:grid-cols-4 sm:items-start md:items-center">
      <div class="mb-1 {card ? 'text-right' : ''} select-none text-base font-medium text-gray-200 sm:col-span-1 sm:mb-0">To [Send Test Email]</div>
      <div class="sm:col-span-3 sm:mt-0">
        <div class="relative w-full mobile:w-3/5 lg:w-1/2">
          <input
            bind:this={input}
            type="text"
            on:input={() => {
              notification.close()
            }}
            bind:value={toAddress}
            placeholder="Enter Email Address"
            class="block w-full appearance-none rounded-md border border-[#a0a1a580] bg-transparent py-2 pl-5 text-base text-gray-800 outline-none placeholder:text-gray-800 hover:border-blue-500 hover:ring-1 hover:ring-blue-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 dark:text-white dark:placeholder:text-slate-500"
          />
          {#if !toAddress.length}
            <div class="absolute left-[170px] top-[17px]">
              <div class="h-2 w-2 animate-pulse rounded-full bg-red-500" />
            </div>
          {/if}
        </div>
      </div>
    </div>
    <div class="sm:grid sm:grid-cols-4 sm:items-start md:items-center">
      <div class="mb-1 select-none {card ? 'text-right' : ''} text-base font-medium text-gray-200 sm:col-span-1 sm:mb-0">Subject</div>
      <div class="sm:col-span-3 sm:mt-0">
        <h1 class="break-all pl-5 text-base font-normal text-slate-800 dark:text-slate-200">{emailTemplate.subject}</h1>
      </div>
    </div>
  </div>

  {@html htmlContent}
</div>

<style global>
  .isList #linkedInBtn {
    display: inline-flex !important;
  }
  .isList {
    font-size: 13px;
  }
  .isList p {
    margin: revert;
  }
  .isList ul {
    display: block;
    line-height: 1.5;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }
  .isList ol {
    display: block;
    list-style-type: decimal;
    line-height: 1.5;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }
  .isList a {
    color: revert;
    text-decoration: revert;
  }
  .card {
    transform: translateX(-83%) translateY(-30%);
    scale: 0.45;
    transform-style: preserve-3d;
    border-radius: 32px;
    box-shadow: 1px 1px 0 1px #f9f9fb, -1px 0 28px 0 rgba(34, 33, 81, 0.01), 28px 28px 28px 0 rgba(34, 33, 81, 0.25);
  }
  .editPreview {
    transform: translateY(-67%);
    /* transform: translateX(-95%) translateY(-45%) rotateX(0deg) rotateZ(0deg); */
    scale: 0.5;
    transform-style: preserve-3d;
    border-radius: 32px;
    box-shadow: 1px 1px 0 1px #f9f9fb, -1px 0 28px 0 rgba(34, 33, 81, 0.01), 28px 28px 28px 0 rgba(34, 33, 81, 0.25);
  }

  @media (min-width: 1024px) {
    .editPreview {
      transform: translateX(-83%) translateY(-61%);
      /* transform: translateX(-95%) translateY(-45%) rotateX(0deg) rotateZ(0deg); */
      scale: 0.45;
      transform-style: preserve-3d;
      border-radius: 32px;
      box-shadow: 1px 1px 0 1px #f9f9fb, -1px 0 28px 0 rgba(34, 33, 81, 0.01), 28px 28px 28px 0 rgba(34, 33, 81, 0.25);
    }
  }

  /* .introSlide {
    animation: 1s linear introSlide;
    animation-fill-mode: forwards;
  }
  @keyframes introSlide {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .introSlide-reverse {
    animation: 1s linear introslide-reverse;
    animation-fill-mode: forwards;
  }
  @keyframes introslide-reverse {
    0% {
      scale: 0.5;
      transform: translateX(-60%) translateY(-35%) rotateX(45deg) rotateZ(-45deg);
    }
    100% {
      scale: 0.5;
      transform: translateX(-54%) translateY(-33%) rotateX(45deg) rotateZ(-45deg);
    }
  }

  .tempName {
    animation: 1s linear tempName;
    animation-fill-mode: forwards;
  }
  @keyframes tempName {
    0% {
      scale: 0.5;
      transform: translateX(-54%) translateY(-33%) rotateX(45deg) rotateZ(-45deg);
    }
    100% {
      scale: 0.5;
      transform: translateX(-60%) translateY(-35%) rotateX(45deg) rotateZ(-45deg);
    }
  }

  .tempName-reverse {
    animation: 1s linear tempName-reverse;
    animation-fill-mode: forwards;
  }
  @keyframes tempName-reverse {
    0% {
      scale: 1;
      transform: translateX(-18%) translateY(-7%) rotateX(45deg) rotateZ(-45deg);
    }
    100% {
      scale: 0.5;
      transform: translateX(-60%) translateY(-35%) rotateX(45deg) rotateZ(-45deg);
    }
  }

  .docTemp {
    animation: 1s linear docTemp;
    animation-fill-mode: forwards;
  }
  @keyframes docTemp {
    0% {
      scale: 0.5;
      transform: translateX(-54%) translateY(-33%) rotateX(45deg) rotateZ(-45deg);
    }
    100% {
      scale: 1;
      transform: translateX(-18%) translateY(-7%) rotateX(45deg) rotateZ(-45deg);
    }
  }
  .docTemp-reverse {
    animation: 1s linear docTemp-reverse;
    animation-fill-mode: forwards;
  }
  @keyframes docTemp-reverse {
    0% {
      transform: translateX(-24%) translateY(0%) rotateX(29deg) rotateZ(-7deg);
      scale: 0.9;
    }
    100% {
      transform: translateX(-18%) translateY(-7%) rotateX(45deg) rotateZ(-45deg);
      scale: 1;
    }
  } */

  /* .subject {
    animation: 1s linear subject;
    animation-fill-mode: forwards;
  }
  @keyframes subject {
    0% {
      transform: translateX(-18%) translateY(-7%) rotateX(45deg) rotateZ(-45deg);
      scale: 1;
    }
    100% {
      transform: translateX(-24%) translateY(0%) rotateX(29deg) rotateZ(-7deg);
      scale: 0.9;
    }
  }

  .subject-reverse {
    animation: 1s linear subject-reverse;
    animation-fill-mode: forwards;
  }
  @keyframes subject-reverse {
    0% {
      transform: translateX(-130%) translateY(-40%) rotateX(0deg) rotateZ(0deg);
      scale: 0.3;
    }
    100% {
      transform: translateX(-24%) translateY(0%) rotateX(29deg) rotateZ(-7deg);
      scale: 0.9;
    }
  }

  .emailDesign {
    animation: 1s linear emailDesign;
    animation-fill-mode: forwards;
  }
  @keyframes emailDesign {
    0% {
      transform: translateX(-24%) translateY(0%) rotateX(29deg) rotateZ(-7deg);
      scale: 0.9;
    }
    100% {
      transform: translateX(-75%) translateY(-27%) rotateX(0deg) rotateZ(0deg);
      scale: 0.5;
    }
  }
  .emailDesign-reverse {
    animation: 1s linear emailDesign-reverse;
    animation-fill-mode: forwards;
  }
  @keyframes emailDesign-reverse {
    0% {
      transform: translateX(-75%) translateY(-20%) rotateX(0deg) rotateZ(0deg);
      scale: 0.5;
    }
    100% {
      transform: translateX(-130%) translateY(-40%) rotateX(0deg) rotateZ(0deg);
      scale: 0.3;
    }
  }

  .header {
    animation: 1s linear header;
    animation-fill-mode: forwards;
  }
  @keyframes header {
    0% {
      transform: translateX(-75%) translateY(-27%) rotateX(0deg) rotateZ(0deg);
      scale: 0.5;
    }
    100% {
      transform: translateX(-75%) translateY(-27%) rotateX(0deg) rotateZ(0deg);
      scale: 0.5;
    }
  } */
</style>
